import {Fragment, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import FormWrapper from '../../shared/FormWrapper'
import OtpInput from '../../shared/OtpInput'
import Input from '../../shared/Input'

import {connect} from '../../../state/hooks/tools'
import {createResource, updateResource} from '../../../lib/asyncMethods'
import {TOKEN, INVITES} from '../../../state/actionTypes'

import './confirmationController.scss'

const ConfirmationController = props => {
  const {token} = props
  const [mode, setMode] = useState('email')
  const [loading, setLoading] = useState(false)
  const [validation, setValidation] = useState({})
  const navigate = useNavigate()
  const methods = useForm()
  const {errors} = methods.formState

  const handleSubmit = data => {
    setLoading(true)
    setValidation(data => ({...data, error: ''}))

    if (mode === 'email') {
      props.createResource({endpoint: `invites/${token.tokenableId}/verify`, attributes: data}).then(response => {
        if (response.success) {
          setValidation(data => ({...data, message: response.message}))
          setMode('account')
        } else {
          setValidation(data => ({...data, error: response.message}))
        }
      }).finally(() => setLoading(false))
    } else {
      props.updateResource({endpoint: `invites/${token.tokenableId}`, attributes: {...data, status: 'accept'}}).then(response => {
        if (response.success)
          navigate('/auth/sign-in')
        else
          setValidation(data => ({...data, error: response.message}))
      }).finally(() => setLoading(false))
    }
  }

  return (
    <Paper elevation={3} className='confirmation-controller' component='div'>
      <Typography variant='h5' sx={{marginBottom: '10px'}}>Account Setup</Typography>
      {
        mode === 'email' && (
          <Typography variant='body1' color='primary' sx={{marginBottom: '10px'}}>
            Check your email for the 6-digit code we sent you, then enter it below.
          </Typography>
        )
      }
      {
        validation.message?.length > 0 && (
          <Typography variant='body1' color='success' sx={{marginBottom: '10px'}}>{validation.message}</Typography>
        )
      }
      {
        validation.error?.length > 0 && (
          <Typography variant='body1' color='error' sx={{marginBottom: '10px'}}>{validation.error}</Typography>
        )
      }
      <FormWrapper methods={methods} handleSubmit={handleSubmit}>
        {
          mode === 'email' ?
            <OtpInput control={methods.control} /> :
            <Fragment>
              <Input
                error={!!errors.password}
                label='Password'
                name='password'
                type='password'
                options={{required: 'Password is required'}}
                helperText={errors.password?.message}
                margin='dense'
              />
              <Input
                error={!!errors.confirmPassword}
                label='Confirm Password'
                name='confirmPassword'
                type='password'
                options={{
                  required: 'Confirm Password is required',
                  validate: value => (value === methods.getValues('password') || 'Passwords do not match')
                }}
                helperText={errors.confirmPassword?.message}
                margin='dense'
              />
            </Fragment>
        }
        <Button
          disabled={loading}
          type='submit'
          variant='contained'
          sx={{color: '#F7F7F7'}}>
          Submit
        </Button>
      </FormWrapper>
    </Paper>
  )
}

ConfirmationController.propTypes = {
  token: PropTypes.object.isRequired
}

const actionCreators = ({invites}) => ({
  createResource: createResource(invites, TOKEN),
  updateResource: updateResource(invites, INVITES)
})

export default connect(null, actionCreators)(ConfirmationController)
